import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Variant } from "../Types";

interface Props {
  variant: Variant;
}

export const Panel: React.FC<Props> = props => {
  return (
    <AnimatePresence>
      {props.variant === "open" && (
        <motion.div
          key="SiteNavigation__Panel"
          className="SiteNavigation__Panel"
          initial={{ opacity: 0, scale: 0.97 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.97 }}
          transition={{ type: "spring", damping: 1000, stiffness: 200 }}
        >
          {props.children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
